<template>

  <v-container fluid v-if="rates">

    <im-page-title
      title="Tarife"
    />

    <im-rates-tool
      @create="goToCreate()"
    />

    <im-rates-list
      :rates="rates"
      @edit="goToEdit($event)"
      @list="getRates($event)"
    />

  </v-container>

</template>


<script>

  import rate_repository from '@/repositories/rate-repository';

  export default {
    components: {
      'im-page-title': () => import('@/components/ThePageTitle'),
      'im-rates-tool': () => import('@/components/Rate/RateToolbar'),
      'im-rates-list': () => import('@/components/Rate/RateList')
    },

    data: () => ({
      rates: null,
    }),

    async created() {
      this.rates = await this.getRates();
    },

    methods: {

      async getRates(pagination) {
        return rate_repository.getRates(this.$store.state.hotel.id,pagination || {size: 10, page: 1});
      },

      goToCreate() {
        const h_id = this.$route.params.hotel;
        this.$router.push({path: `/hotels/${h_id}/rates/create`})
      },

      goToEdit(rate) {
        const h_id = this.$route.params.hotel;
        const r_id = rate.id;
        this.$router.push({path: `/hotels/${h_id}/rates/${r_id}`})
      }

    }
  }

</script>